import React from "react";
import { Modal, Col, FormGroup, Row, FormLabel } from "react-bootstrap";
import { labels } from "../../../../localization/labels";
import SubmitButton from "../../../core/SubmitButton";
import SubmitControl from "../../../core/SubmitControl/SubmitControl";

const Settings = ({
  show,
  handleClose,
  onSave,
  onChange,
  party,
  onClassificationSubscriptionsClick,
  openInNewTab
}) => {
  return (
    <>
      <Modal show={show} onHide={handleClose} animation={true}>
        <Modal.Header closeButton>
          <Modal.Title>{labels.settings}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {party?.partySubscription && (
            <>
              <FormGroup
                controlId="party.partySubscription"
                as={Row}
                className="withoutBottomMargin"
              >
                <FormLabel column sm="2" className="control-label">
                  {labels.notifications}
                </FormLabel>
                <Col
                  sm="10"
                  className="d-flex align-items-center justify-content-between"
                >
                  <FormGroup
                    controlId="party.partySubscription.emailNotification"
                    className="withoutBottomMargin"
                  >
                    <SubmitControl
                      type="checkbox"
                      title={labels.email}
                      value={party.partySubscription.emailNotification}
                      onChange={onChange}
                    />
                  </FormGroup>
                </Col>
              </FormGroup>
              <Row>
                <Col sm="2"> </Col>
                <Col sm="10">
                  <SubmitButton
                    type="link"
                    size="sm"
                    style={{ "padding-left": 0 }}
                    onClick={onClassificationSubscriptionsClick}
                    text={labels.classificationSubscriptions}
                    openInNewTab={openInNewTab}
                  ></SubmitButton>
                </Col>
              </Row>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <SubmitButton type="close" onClick={handleClose} showLoader={false} />
          <SubmitButton type="save" onClick={onSave} />
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default Settings;
